import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import s from '../ModuleOverview.module.css';
import { getAVGScoreColumn } from '../../QuantQual/qqComponents/componentFunctions';
import { roundtoTwoDecimals } from '../../../../util/util';
import { CLICK_PERFORMANCE_BY_UNIT } from '../../../../analyticsEvents';

import PaginatedTable from '../../../../../components/PaginatedTable/PaginatedTable';

const performanceByUnitComponent = (props) => {
  const { studentId, reportType, sendEvent } = props;

  const dispatch = useDispatch();

  const handleUnitClick = () => {
    dispatch(sendEvent(CLICK_PERFORMANCE_BY_UNIT));
  };

  const tableStyle = [
    {
      row: 'styledRow',
      cells: [
        { accessor: 'name', alignment: 'left' },
        { accessor: 'assignments', alignment: 'right' },
        { accessor: 'completedAssignmentsPercentage', alignment: 'right' },
        { accessor: 'correctOnFirstTry', alignment: 'right' },
      ],
    },
  ];

  const avgScoreColumn = {
    accessor: 'correctOnFirstTry',
    Header: 'Questions Correct on First Try',
    cell:
      (item) => {
        if (item.correctOnFirstTry === '—') {
          item.isNullState = true;
        }
        return (getAVGScoreColumn(item, 'correctOnFirstTry'));
      },
  };

  const tableColumns = [
    {
      accessor: 'name',
      Header: 'Unit Title',
      cell: item =>
        (<button
          role="link"
          className={s.submoduleLink}
          onClick={() => {
            const tabName = studentId ? `reports/type/student-unit/${studentId}/${item.id}?activeTab=Reports` : `reports/type/unit/${item.id}`;
            props.onTabChange(tabName);
            handleUnitClick();
          }}
        >
          {item.name}
        </button>)
      ,
    },
    {
      accessor: 'assignments',
      Header: 'Assignments in Unit',
      cell: item => (item.assignments >= 0 ? item.assignments : 0),
    },
    {
      accessor: 'completedAssignmentsPercentage',
      Header: 'Assignments Completed',
      cell: (item) => {
        const formatedItem = item.completedAssignmentsPercentage < 0 ? '—' : `${roundtoTwoDecimals(item.completedAssignmentsPercentage)}%`;
        return formatedItem;
      },
    },
  ];
  tableColumns.push(avgScoreColumn);

  const modalContent = (
    <div className={s.modalContent}>
      <p><b>Assignments in Unit</b> represents the total number of resources (readings, activities, assessments) assigned to your students in this Unit.</p>
      <p><b>Assignments completed</b> represents the proportion of assignments in this Unit completed across all students in your class.</p>
      <p><b>Questions correct on first try</b> represents, across all questions answered in this Unit by all students in your class, the proportion that were correct on a student&apos;s first try.</p>
    </div>
  );

  const nullStateContent = (
    <p>
      There are no assignments covering this unit.<br />
      Go to <button role="link" onClick={() => { props.onTabChange('assignments'); }}>Course Planner</button> tab to setup and manage assignments.
    </p>
  );

  const data = props.data.map(unit => ({
    ...unit,
  }));

  return (
    <div className={s.performanceBySubmodule} data-test-id={`${reportType || 'overview'}-performance-by-unit`}>
      <PaginatedTable
        id="performanceByUnit"
        className={s.performanceCard}
        title="Performance by Unit"
        data={data}
        tableStyle={tableStyle}
        tableColumns={tableColumns}
        sortBy={['correctOnFirstTry', 'completedAssignmentsPercentage', 'assignments', 'name']}
        direction="asc"
        modalContent={modalContent}
        nullState={nullStateContent}
        styleFunction={() => 'styledRow'}
        reportType={reportType}
      />
    </div>
  );
};

performanceByUnitComponent.propTypes = {
  data: PropTypes.array,
  onTabChange: PropTypes.func,
  sendEvent: PropTypes.func,
  reportType: PropTypes.string,
  studentId: PropTypes.string,
};

export default performanceByUnitComponent;

